import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Params } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { log } from "console";
import { ColorScaleInterpolationMode } from "igniteui-angular-charts";
import { LotteryInstallmentConfigurationModel } from "src/app/model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "src/app/model/SchemeInstallmentConfigurationModel";
import { TenementInsConfigInitModel } from "src/app/model/TenementInsConfigInitModel";
import { TenementInstallmentConfigurationModel } from "src/app/model/TenementInstallmentConfigurationModel";
import { TenementListResponse } from "src/app/model/TenementListResponse";
import { InstallmentConfigService } from "src/app/services/installment-config.service";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TenementInstallmentConfigService } from "src/app/services/tenement-installment-config.service";

@Component({
  selector: "app-secure-tenement-installment-config-add-modal",
  templateUrl: "./tenement-installment-config-add-model.component.html",
  styleUrls: ["./tenement-installment-config-add-model.component.scss"],
})
export class TenementInstallmentConfigAddModalComponent implements OnInit {
  @Input() selectedTenement: TenementListResponse;
  @Input() tenementConfigs: TenementInsConfigInitModel[];
  @Input() installmentTypes: { [key: number]: string };
  @Input() otherInstallmentNames: string[];
  otherInstallmentNamesT: string[];
  @Input() tenementKeys: number[];
  @Input() lotteryCode: string;
  @Input() lotteryName: string;
  tenementInstallmentConfigs: TenementInsConfigInitModel[] = [];
  alltenementInstallmentConfigs: TenementInsConfigInitModel[] = [];
  updatedConfigKeys: number[] = [];
  isLoading = false;
  pageMode: string = "";
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  installmentConfigurationType: string;
  header: string;
  isAmountReadOnly: boolean = true;

  selectedFile: File;
  corrigendumDocFile: string | ArrayBuffer;
  corrigendumDocFileForView: string | ArrayBuffer;
  corrigendumDocFileName: string;
  docNameWithoutExtnsn: string;

  installmentType: string;
  installmentOrder: number;
  initialPercent: number;
  initialAmount: number;
  initialPayDays: number;
  initialWithIntPayDays: number;
  startDate: string;
  otherInstallmentType: string;
  otherInstallmentOrder: number;
  saved: boolean = false;

  viewInstallmentType: string;
  viewLottery: number;
  viewschemeKey: number;

  viewInstallmentOrder: number;
  lotteries: { [key: number]: string };
  schemes: { [key: number]: string };
  installmentPercent: number;
  installmentDuePaymentDays: number;
  installmentDuePaymentDaysWithInterest: number;
  lotteryKey: number;
  lotteryInstKey: number;
  installmentAmount: number;
  schemeInstKey: number;

  headerMode: string = "";

  schemeKey: number;
  schemeInstallmentConfigs: SchemeInstallmentConfigurationModel[] = [];
  isAddAllowedForLottery: boolean;
  isAddAllowedForScheme: boolean;
  key: number;
  showConfigTable: boolean;
  constructor(
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController,
    private installmentConfigService: InstallmentConfigService,
    private tenementInsConfigService: TenementInstallmentConfigService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.tenementInstallmentConfigs = this.tenementConfigs;

    this.form = new FormGroup({
      otherCharges: new FormControl(this.initialPercent === 0),
      instPaymentInterestRate: new FormControl(null, [
        Validators.pattern(/^\d*\.?\d*$/),
        Validators.max(100),
        Validators.min(0),
      ]),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      installmentDuePaymentDays: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      installmentDuePaymentDaysWithInterest: new FormControl(null, [
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      intrestChartLst: new FormArray([]),
      corrigendumDocFile: new FormControl(null),
    });

    this.showConfigTable =
      this.tenementInstallmentConfigs.length > 0 ? true : false;

    console.log("this.showConfigTable > ", this.showConfigTable);

    if (!this.showConfigTable) {
      console.log("In New Add logic");
      this.headerMode = "Detail";

      let totalPercent =
        this.tenementInstallmentConfigs &&
        this.tenementInstallmentConfigs.length > 0 &&
        this.tenementInstallmentConfigs.filter((s) => s.otherCharge === "N")
          .length > 0
          ? this.tenementInstallmentConfigs
              .filter((s) => s.otherCharge === "N")
              .map((obj) => obj.installmentPercent)
              .reduce((o1, o2) => o1 + o2)
          : 0;
      console.log("totalPercent>>J>>", totalPercent);

      let otherCharges =
        this.tenementInstallmentConfigs &&
        this.tenementInstallmentConfigs.length > 0 &&
        this.tenementInstallmentConfigs.filter((l) => l.otherCharge === "Y")
          .length > 0
          ? Math.max.apply(
              Math,
              this.tenementInstallmentConfigs
                .filter((s) => s.otherCharge === "Y")
                .map((obj) => obj.key)
            ) + 1
          : 11;
      console.log("otherCharges>>J>>", otherCharges);

      this.otherInstallmentNamesT = this.otherInstallmentNames.filter(
        (o) =>
          (this.tenementInstallmentConfigs &&
          this.tenementInstallmentConfigs.length > 0
            ? this.tenementInstallmentConfigs
                .filter((l) => l.otherCharge === "Y")
                .map((l) => l.installmentType)
            : []
          ).indexOf(o) < 0
      );
      console.log("otherInstallmentNamesT >>J>>", this.otherInstallmentNamesT);

      let lotteryInstallmentConfigKeys = this.tenementInstallmentConfigs?.map(
        (l) => l.key
      );
      console.log(
        "lotteryInstallmentConfigKeys >>J>>",
        lotteryInstallmentConfigKeys
      );
      let remainingInstallmentTypes = Object.keys(this.installmentTypes)
        ?.map((o) => {
          return { key: +o, value: this.installmentTypes[o] };
        })
        ?.filter((i) => lotteryInstallmentConfigKeys.indexOf(i.key) < 0)
        .sort((a, b) => {
          return a.key - b.key;
        });

      console.log("remainingInstallmentTypes >>J>>", remainingInstallmentTypes);

      let installmentType = remainingInstallmentTypes[0];

      console.log("installmentType >>J>>", installmentType);
      this.installmentConfigurationType = "Tenement";
      this.header = this.selectedTenement.lotteryCode
        ? this.selectedTenement.lotteryCode +
          " - " +
          this.selectedTenement.lotteryName
        : this.lotteryCode + " - " + this.lotteryName;
      this.installmentType = totalPercent < 100 ? installmentType.value : null;
      this.installmentOrder = totalPercent < 100 ? installmentType.key : null;
      this.initialPercent = totalPercent < 100 ? 100 - totalPercent : 0;
      this.otherInstallmentType = !otherCharges ? "OTHER_CHARGES" : null;
      this.otherInstallmentOrder = otherCharges;
      // this.otherInstallmentNames = otherInstallmentNamesT;
      this.viewInstallmentType = this.installmentType;

      if (this.initialPercent === 0) {
        this.form.removeControl("installmentPercent");
        this.form.addControl(
          "installmentAmount",
          new FormControl(null, [
            Validators.required,
            Validators.pattern(/^\d+$/),
          ])
        );
        this.form.addControl(
          "otherChargeName",
          new FormControl(null, [Validators.required])
        );
        this.viewInstallmentOrder = this.otherInstallmentOrder;

        console.log(
          "this.viewInstallmentOrder if>>",
          this.viewInstallmentOrder
        );
        console.log(
          "this.otherInstallmentOrder if>>",
          this.otherInstallmentOrder
        );
      } else {
        this.form.removeControl("installmentAmount");
        this.form.removeControl("otherChargeName");
        this.form.addControl(
          "installmentPercent",
          new FormControl(null, [
            Validators.required,
            Validators.pattern(/^\d+$/),
            Validators.max(this.initialPercent),
            Validators.min(1),
          ])
        );
        this.viewInstallmentOrder = this.installmentOrder;
        console.log(
          "this.viewInstallmentOrder else>>",
          this.viewInstallmentOrder
        );
        console.log("this.installmentOrder else>>", this.installmentOrder);
      }

      let selectedIntrestChartLst: FormArray = this.form.get(
        "intrestChartLst"
      ) as FormArray;
      selectedIntrestChartLst.push(
        new FormGroup({
          key: new FormControl(null),
          startDate: new FormControl(null),
          endDate: new FormControl(null),
          instPaymentInterestRate: new FormControl(null),
        })
      );
    } else {
      this.headerMode = "List";
      this.installmentConfigurationType = "Tenement";
    }
  }

  onSelectOtherCharges(e: any) {
    if (e?.target?.checked === true) {
      this.form.removeControl("installmentPercent");
      this.form.addControl(
        "installmentAmount",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
        ])
      );
      this.form.addControl(
        "otherChargeName",
        new FormControl(null, [Validators.required])
      );
      this.viewInstallmentOrder = this.otherInstallmentOrder;
    } else {
      this.form.removeControl("installmentAmount");
      this.form.removeControl("otherChargeName");
      this.form.addControl(
        "installmentPercent",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.max(this.initialPercent),
          Validators.min(1),
        ])
      );
      this.viewInstallmentOrder = this.installmentOrder;
    }
  }

  onSubmit() {
    console.log("In onSubmit()");
    console.log("this.form.value", this.form.valid);
    if (this.form.valid) {
      if (this.form.value.installmentDuePaymentDaysWithInterest) {
        if (
          this.form.value.installmentDuePaymentDays >
          this.form.value.installmentDuePaymentDaysWithInterest
        ) {
          this.isSubmitDisabled = false;
          alert(
            "Installment Pay days with interest should be more than or equal to Installment Pay days"
          );
        } else {
          this.tenementInstallmentConfigs.push(
            new TenementInsConfigInitModel(
              this.viewInstallmentOrder,
              this.selectedTenement.tenementKey,
              this.form.value.otherCharges
                ? this.form.value.otherChargeName
                : this.viewInstallmentType,
              this.form.value.installmentAmount !== null ||
              this.form.value.installmentAmount !== undefined
                ? this.form.value.installmentAmount
                : null,
              null,
              null,
              null,
              this.form.value.instPaymentInterestRate,
              null,
              null,
              this.form.value.installmentDuePaymentDays,
              this.form.value.installmentDuePaymentDaysWithInterest,
              this.form.value.otherCharges ? "Y" : "N",
              null,
              this.form.value.installmentPercent !== null ||
              this.form.value.installmentPercent !== undefined
                ? this.form.value.installmentPercent
                : null,
              null,
              this.form.value.intrestChartLst.map((ur) => ({
                key: ur.key,
                startDate: ur.startDate,
                endDate: ur.endDate,
                instPaymentInterestRate: ur.instPaymentInterestRate,
              })),
              this.corrigendumDocFile ? this.corrigendumDocFile : "",
              "false",
              ""
            )
          );

          this.tenementInstallmentConfigs =
            this.tenementInstallmentConfigs.sort((a, b) => a.key - b.key);
          // console.log("Check the new tenement config if>>", this.tenementInstallmentConfigs);

          this.showConfigTable =
            this.tenementInstallmentConfigs.length > 0 ? true : false;

          this.alltenementInstallmentConfigs = [];
          this.alltenementInstallmentConfigs =
            this.alltenementInstallmentConfigs.concat(
              this.tenementInstallmentConfigs
            );

          // console.log("this.alltenementInstallmentConfigs if>>", this.alltenementInstallmentConfigs);
          this.isSubmitDisabled = false;
          this.headerMode = "List";
          this.showConfigTable = true;
          this.pageMode = "";
        }
      } else {
        this.tenementInstallmentConfigs.push(
          new TenementInsConfigInitModel(
            null,
            this.selectedTenement.tenementKey,
            this.form.value.otherCharges
              ? this.form.value.otherChargeName
              : this.viewInstallmentType,
            this.form.value.installmentAmount !== null ||
            this.form.value.installmentAmount !== undefined
              ? this.form.value.installmentAmount
              : null,
            null,
            null,
            null,
            this.form.value.instPaymentInterestRate,
            null,
            null,
            this.form.value.installmentDuePaymentDays,
            this.form.value.installmentDuePaymentDaysWithInterest,
            this.form.value.otherCharges ? "Y" : "N",
            null,
            this.form.value.installmentPercent !== null ||
            this.form.value.installmentPercent !== undefined
              ? this.form.value.installmentPercent
              : null,
            null,
            this.form.value.intrestChartLst.map((ur) => ({
              key: ur.key,
              startDate: ur.startDate,
              endDate: ur.endDate,
              instPaymentInterestRate: ur.instPaymentInterestRate,
            })),
            this.corrigendumDocFile ? this.corrigendumDocFile : "",
            "false",
            ""
          )
        );

        this.tenementInstallmentConfigs = this.tenementInstallmentConfigs.sort(
          (a, b) => a.key - b.key
        );
        this.showConfigTable =
          this.tenementInstallmentConfigs.length > 0 ? true : false;

        this.alltenementInstallmentConfigs = [];
        this.alltenementInstallmentConfigs =
          this.alltenementInstallmentConfigs.concat(
            this.tenementInstallmentConfigs
          );

        this.isSubmitDisabled = false;
        this.headerMode = "List";
        this.showConfigTable = true;
        this.pageMode = "";
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }

  onTenementInstallmentConfigurationAdd() {
    this.headerMode = "Detail";
    this.showConfigTable = false;
    this.pageMode = "";
    this.form = new FormGroup({
      otherCharges: new FormControl(this.initialPercent === 0),
      instPaymentInterestRate: new FormControl(null, [
        Validators.pattern(/^\d*\.?\d*$/),
        Validators.max(100),
        Validators.min(0),
      ]),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      installmentDuePaymentDays: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      installmentDuePaymentDaysWithInterest: new FormControl(null, [
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      intrestChartLst: new FormArray([]),
      corrigendumDocFile: new FormControl(null),
    });

    let totalPercent: any;
    let otherCharges: any;
    let lotteryInstallmentConfigKeys: any;
    let installmentType: any;

    totalPercent =
      this.tenementInstallmentConfigs &&
      this.tenementInstallmentConfigs.length > 0 &&
      this.tenementInstallmentConfigs.filter((s) => s.otherCharge === "N")
        .length > 0
        ? this.tenementInstallmentConfigs
            .filter((s) => s.otherCharge === "N")
            .map((obj) => obj.installmentPercent)
            .reduce((o1, o2) => o1 + o2)
        : 0;

    otherCharges =
      this.tenementInstallmentConfigs &&
      this.tenementInstallmentConfigs.length > 0 &&
      this.tenementInstallmentConfigs.filter((l) => l.otherCharge === "Y")
        .length > 0
        ? Math.max.apply(
            Math,
            this.tenementInstallmentConfigs
              .filter((s) => s.otherCharge === "Y")
              .map((obj) => obj.key)
          ) + 1
        : 11;

    this.otherInstallmentNamesT = this.otherInstallmentNames.filter(
      (o) =>
        (this.tenementInstallmentConfigs &&
        this.tenementInstallmentConfigs.length > 0
          ? this.tenementInstallmentConfigs
              .filter((l) => l.otherCharge === "Y")
              .map((l) => l.installmentType)
          : []
        ).indexOf(o) < 0
    );

    lotteryInstallmentConfigKeys = this.tenementInstallmentConfigs?.map(
      (l) => l.key
    );

    let remainingInstallmentTypes = Object.keys(this.installmentTypes)
      ?.map((o) => {
        return { key: +o, value: this.installmentTypes[o] };
      })
      ?.filter((i) => lotteryInstallmentConfigKeys.indexOf(i.key) < 0)
      .sort((a, b) => {
        return a.key - b.key;
      });
    installmentType = remainingInstallmentTypes[0];

    this.installmentConfigurationType = "Tenement";
    this.header = this.selectedTenement.lotteryCode
      ? this.selectedTenement.lotteryCode +
        " - " +
        this.selectedTenement.lotteryName
      : this.lotteryCode + " - " + this.lotteryName;
    this.installmentType = totalPercent < 100 ? installmentType.value : null;
    this.installmentOrder = totalPercent < 100 ? installmentType.key : null;
    this.initialPercent = totalPercent < 100 ? 100 - totalPercent : 0;
    this.otherInstallmentType = !otherCharges ? "OTHER_CHARGES" : null;
    this.otherInstallmentOrder = otherCharges;
    this.viewInstallmentType = this.installmentType;

    if (this.initialPercent === 0) {
      this.form.removeControl("installmentPercent");
      this.form.addControl(
        "installmentAmount",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
        ])
      );
      this.form.addControl(
        "otherChargeName",
        new FormControl(null, [Validators.required])
      );
      this.viewInstallmentOrder = this.otherInstallmentOrder;
    } else {
      this.form.removeControl("installmentAmount");
      this.form.removeControl("otherChargeName");
      this.form.addControl(
        "installmentPercent",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.max(this.initialPercent),
          Validators.min(1),
        ])
      );
      this.viewInstallmentOrder = this.installmentOrder;
    }
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;
    selectedIntrestChartLst.push(
      new FormGroup({
        key: new FormControl(null),
        startDate: new FormControl(null, Validators.required),
        endDate: new FormControl(null),
        instPaymentInterestRate: new FormControl(null, Validators.required),
      })
    );

    this.showConfigTable = false;
    this.form;
  }

  deleteTenementInstallmentConfig(
    t: TenementInstallmentConfigurationModel,
    i: number
  ) {
    if (i >= 0 && i < this.tenementInstallmentConfigs.length) {
      const deletedItem = this.tenementInstallmentConfigs.splice(i, 1)[0];
    } else {
      console.error("Invalid index provided:", i);
    }
  }
  deleteTenementIntersetConfig(key: number) {
    this.tenementInstallmentConfigs = this.tenementInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }

  cancel() {
    if (this.headerMode === "Detail") {
      this.headerMode = "List";
      this.pageMode = null;
      this.showConfigTable = true;
    }
  }

  onTenementInstallmentConfigurationEdit(t: TenementInsConfigInitModel) {
    this.pageMode = "EDIT";
    this.showConfigTable = false;
    this.headerMode = "Detail";
    this.otherInstallmentNamesT = this.otherInstallmentNames;
    this.isAmountReadOnly = true;
    this.selectedFile = null;

    this.form = new FormGroup({
      // installmentPercent: new FormControl(null),
      // installmentAmount: new FormControl(null),
      key: new FormControl(null),
      tenementKey: new FormControl(null),
      otherCharges: new FormControl(t?.otherCharge === "Y"),
      instPaymentInterestRate: new FormControl(null, [
        Validators.pattern(/^\d*\.?\d*$/),
        Validators.max(100),
        Validators.min(0),
      ]),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      installmentDuePaymentDays: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      installmentDuePaymentDaysWithInterest: new FormControl(null, [
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      intrestChartLst: new FormArray([]),
      corrigendumDocFile: new FormControl(null),
    });

    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;

    t.intrestChartLst.forEach((o) => {
      selectedIntrestChartLst.push(
        new FormGroup({
          key: new FormControl(o?.key),
          startDate: new FormControl(o?.startDate, Validators.required),
          endDate: new FormControl(o?.endDate),
          instPaymentInterestRate: new FormControl(
            o?.instPaymentInterestRate,
            Validators.required
          ),
        })
      );
    });

    if (t?.otherCharge === "Y") {
      this.form.addControl(
        "installmentAmount",
        new FormControl(t?.installmentAmount, [
          Validators.required,
          Validators.pattern(/^\d+$/),
        ])
      );
      this.form.addControl(
        "otherChargeName",
        new FormControl(t?.installmentType, [Validators.required])
      );
      this.viewInstallmentOrder = this.otherInstallmentOrder; //??
    } else {
      this.form.addControl(
        "installmentPercent",
        new FormControl(t?.installmentPercent, [
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.max(this.initialPercent),
          Validators.min(1),
        ])
      );
      this.viewInstallmentOrder = this.installmentOrder; //??
    }

    this.form.patchValue({
      key: t?.key,
      installmentType: t?.installmentType,
      installmentPercent: t?.installmentPercent,
      instPaymentInterestRate: t?.instPaymentInterestRate,
      installmentDuePaymentDays: t?.installmentDuePaymentDays,
      installmentDuePaymentDaysWithInterest:
        t?.installmentDuePaymentDaysWithInterest,
      installmentAmount: t?.installmentAmount,
      tenementKey: t?.tenementKey,
    });
    this.viewInstallmentType = t.installmentType;
    this.header = this.selectedTenement.lotteryCode
      ? this.selectedTenement.lotteryCode +
        " - " +
        this.selectedTenement.lotteryName
      : this.lotteryCode + " - " + this.lotteryName;

    if (t.corrigendumDocFileName && t.corrigendumDocFileName !== null) {
      this.corrigendumDocFileName = t.corrigendumDocFileName;
    }
  }

  updateData() {
    if (this.form.get("otherCharges").value) {
      if (
        this.form.get("otherChargeName").value !== null &&
        this.form.get("otherChargeName").value !== undefined
      ) {
        if (this.form.get("otherChargeName").value == "MAINTENANCE_CHARGE") {
          if (this.isAmountReadOnly === false) {
            if (
              this.corrigendumDocFile === null ||
              this.corrigendumDocFile === ""
            ) {
              return this.installmentConfigService.errorToast(
                "Please upload the Corrigendum File."
              );
            }
          }
        }
      }
    }

    if (this.isAmountReadOnly === false) {
      if (
        this.corrigendumDocFile === null ||
        this.corrigendumDocFile === undefined
      ) {
        return this.tenementInsConfigService.errorToast(
          "Please upload the File"
        );
      }
    }

    if (this.form.valid) {
      if (this.form.value.installmentDuePaymentDaysWithInterest) {
        if (
          this.form.value.installmentDuePaymentDays >
          this.form.value.installmentDuePaymentDaysWithInterest
        ) {
          this.isSubmitDisabled = false;
          alert(
            "Installment Pay days with interest should be more than or equal to Installment Pay days"
          );
        } else {
          const indexToUpdate = this.tenementInstallmentConfigs.findIndex(
            (config) => config.installmentType === this.viewInstallmentType
          );
          if (indexToUpdate !== -1) {
            this.updatedConfigKeys.push(
              this.tenementInstallmentConfigs[indexToUpdate].key
            );

            const configToUpdate =
              this.tenementInstallmentConfigs[indexToUpdate];

            configToUpdate.key =
              this.tenementInstallmentConfigs[indexToUpdate].key;
            configToUpdate.tenementKey = this.selectedTenement.tenementKey;
            configToUpdate.installmentType = this.form.value.otherCharges
              ? this.form.value.otherChargeName
              : this.viewInstallmentType;
            configToUpdate.installmentAmount =
              this.form.value.installmentAmount !== null ||
              this.form.value.installmentAmount !== undefined
                ? this.form.value.installmentAmount
                : null;
            configToUpdate.displayOrder = null;
            configToUpdate.instPaymentStartDate = null;
            configToUpdate.instPaymentEndDate = null;
            configToUpdate.instPaymentInterestRate =
              this.form.value.instPaymentInterestRate;
            configToUpdate.instPaymentEndDateWithInterest = null;
            configToUpdate.installmentStartPaymentDays = null;
            configToUpdate.installmentDuePaymentDays =
              this.form.value.installmentDuePaymentDays;
            configToUpdate.installmentDuePaymentDaysWithInterest =
              this.form.value.installmentDuePaymentDaysWithInterest;
            configToUpdate.otherCharge = this.form.value.otherCharges
              ? "Y"
              : "N";
            configToUpdate.tenementInstKey = null;
            configToUpdate.installmentPercent =
              this.form.value.installmentPercent !== null ||
              this.form.value.installmentPercent !== undefined
                ? this.form.value.installmentPercent
                : null;
            configToUpdate.lotteryKey = null;
            configToUpdate.intrestChartLst =
              this.form.value.intrestChartLst.map((ur) => ({
                key: ur.key,
                startDate: ur.startDate,
                endDate: ur.endDate,
                instPaymentInterestRate: ur.instPaymentInterestRate,
              }));
            configToUpdate.corrigendumDocFile = this.corrigendumDocFile
              ? this.corrigendumDocFile
              : "";
            configToUpdate.isRecordUpdated = "true";
          } else {
            this.updatedConfigKeys.push(
              this.tenementInstallmentConfigs[indexToUpdate].key
            );

            this.tenementInstallmentConfigs.push(
              new TenementInsConfigInitModel(
                this.tenementInstallmentConfigs[indexToUpdate].key,
                this.selectedTenement.tenementKey,
                this.form.value.otherCharges
                  ? this.form.value.otherChargeName
                  : this.viewInstallmentType,
                this.form.value.installmentAmount !== null ||
                this.form.value.installmentAmount !== undefined
                  ? this.form.value.installmentAmount
                  : null,
                null,
                null,
                null,
                this.form.value.instPaymentInterestRate,
                null,
                null,
                this.form.value.installmentDuePaymentDays,
                this.form.value.installmentDuePaymentDaysWithInterest,
                this.form.value.otherCharges ? "Y" : "N",
                null,
                this.form.value.installmentPercent !== null ||
                this.form.value.installmentPercent !== undefined
                  ? this.form.value.installmentPercent
                  : null,
                null,
                this.form.value.intrestChartLst.map((ur) => ({
                  key: ur.key,
                  startDate: ur.startDate,
                  endDate: ur.endDate,
                  instPaymentInterestRate: ur.instPaymentInterestRate,
                })),
                this.corrigendumDocFile ? this.corrigendumDocFile : "",
                "false",
                this.corrigendumDocFile ? this.corrigendumDocFileName : ""
              )
            );
          }

          this.tenementInstallmentConfigs =
            this.tenementInstallmentConfigs.sort((a, b) => a.key - b.key);

          this.showConfigTable =
            this.tenementInstallmentConfigs.length > 0 ? true : false;

          this.alltenementInstallmentConfigs = [];
          this.alltenementInstallmentConfigs =
            this.alltenementInstallmentConfigs.concat(
              this.tenementInstallmentConfigs
            );

          this.isSubmitDisabled = false;
          this.headerMode = "List";
          this.showConfigTable = true;
          this.pageMode = "";
        }
      } else {
        const indexToUpdate = this.tenementInstallmentConfigs.findIndex(
          (config) => config.installmentType === this.installmentType
        );

        if (indexToUpdate !== -1) {
          this.updatedConfigKeys.push(
            this.tenementInstallmentConfigs[indexToUpdate].key
          );

          const configToUpdate = this.tenementInstallmentConfigs[indexToUpdate];

          configToUpdate.key =
            this.tenementInstallmentConfigs[indexToUpdate].key;
          configToUpdate.tenementKey = this.selectedTenement.tenementKey;
          configToUpdate.installmentType = this.form.value.otherCharges
            ? this.form.value.otherChargeName
            : this.viewInstallmentType;
          configToUpdate.installmentAmount =
            this.form.value.installmentAmount !== null ||
            this.form.value.installmentAmount !== undefined
              ? this.form.value.installmentAmount
              : null;
          configToUpdate.displayOrder = null;
          configToUpdate.instPaymentStartDate = null;
          configToUpdate.instPaymentEndDate = null;
          configToUpdate.instPaymentInterestRate =
            this.form.value.instPaymentInterestRate;
          configToUpdate.instPaymentEndDateWithInterest = null;
          configToUpdate.installmentStartPaymentDays = null;
          configToUpdate.installmentDuePaymentDays =
            this.form.value.installmentDuePaymentDays;
          configToUpdate.installmentDuePaymentDaysWithInterest =
            this.form.value.installmentDuePaymentDaysWithInterest;
          configToUpdate.otherCharge = this.form.value.otherCharges ? "Y" : "N";
          configToUpdate.tenementInstKey = null;
          configToUpdate.installmentPercent =
            this.form.value.installmentPercent !== null ||
            this.form.value.installmentPercent !== undefined
              ? this.form.value.installmentPercent
              : null;
          configToUpdate.lotteryKey = null;
          configToUpdate.intrestChartLst = this.form.value.intrestChartLst.map(
            (ur) => ({
              key: ur.key,
              startDate: ur.startDate,
              endDate: ur.endDate,
              instPaymentInterestRate: ur.instPaymentInterestRate,
            })
          );
          configToUpdate.corrigendumDocFile = this.corrigendumDocFile
            ? this.corrigendumDocFile
            : "";
          configToUpdate.isRecordUpdated = "true";
        } else {
          this.updatedConfigKeys.push(
            this.tenementInstallmentConfigs[indexToUpdate].key
          );
          this.tenementInstallmentConfigs.push(
            new TenementInsConfigInitModel(
              this.tenementInstallmentConfigs[indexToUpdate].key,
              this.selectedTenement.tenementKey,
              this.form.value.otherCharges
                ? this.form.value.otherChargeName
                : this.viewInstallmentType,
              this.form.value.installmentAmount !== null ||
              this.form.value.installmentAmount !== undefined
                ? this.form.value.installmentAmount
                : null,
              null,
              null,
              null,
              this.form.value.instPaymentInterestRate,
              null,
              null,
              this.form.value.installmentDuePaymentDays,
              this.form.value.installmentDuePaymentDaysWithInterest,
              this.form.value.otherCharges ? "Y" : "N",
              null,
              this.form.value.installmentPercent !== null ||
              this.form.value.installmentPercent !== undefined
                ? this.form.value.installmentPercent
                : null,
              null,
              this.form.value.intrestChartLst.map((ur) => ({
                key: ur.key,
                startDate: ur.startDate,
                endDate: ur.endDate,
                instPaymentInterestRate: ur.instPaymentInterestRate,
              })),
              this.corrigendumDocFile ? this.corrigendumDocFile : "",
              "false",
              this.corrigendumDocFile ? this.corrigendumDocFileName : ""
            )
          );
        }

        this.tenementInstallmentConfigs = this.tenementInstallmentConfigs.sort(
          (a, b) => a.key - b.key
        );
        this.showConfigTable =
          this.tenementInstallmentConfigs.length > 0 ? true : false;

        this.alltenementInstallmentConfigs = [];
        this.alltenementInstallmentConfigs =
          this.alltenementInstallmentConfigs.concat(
            this.tenementInstallmentConfigs
          );
        this.isSubmitDisabled = false;
        this.headerMode = "List";
        this.showConfigTable = true;
        this.pageMode = "";
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }

  onTenementInstallmentConfigurationSave() {
    console.log("In Save and Update call");

    if (this.saved === false && this.tenementInstallmentConfigs.length <= 0) {
      return this.tenementInsConfigService.errorToast(
        "Please add Data to save Configuration against Tenement"
      );
    }

    if (
      this.saved === true &&
      this.corrigendumDocFile !== "" &&
      this.corrigendumDocFile !== null &&
      this.corrigendumDocFile !== undefined
    ) {
      console.log("Update call");
      return this.modalCtrl.dismiss(
        {
          tenementInstallmentConfigs: this.tenementInstallmentConfigs,
          tenementKeys: this.tenementKeys,
        },
        "update"
      );
    } else if (this.saved === true) {
      console.log("Update call without file");
      return this.modalCtrl.dismiss(
        {
          tenementInstallmentConfigs: this.tenementInstallmentConfigs,
          tenementKeys: this.tenementKeys,
        },
        "update"
      );
    } else {
      console.log("Save call");
      return this.modalCtrl.dismiss(
        {
          tenementInstallmentConfigs: this.tenementInstallmentConfigs,
          tenementKeys: this.tenementKeys,
        },
        "submit"
      );
    }
  }

  downloadSelectedFile() {
    if (
      this.corrigendumDocFile !== undefined ||
      this.corrigendumDocFile !== null
    ) {
      this.downloadFile(this.corrigendumDocFile, this.corrigendumDocFileName);
    } else {
      return this.tenementInsConfigService.errorToast("Please upload the File");
    }
  }

  downloadDocumentFile() {
    console.log("downloadDocumentFile this.form.value>> ", this.form.value);

    if (this.form.value.otherChargeName !== "MAINTENANCE_CHARGE") {
      return this.tenementInsConfigService.errorToast("Invalid Charges Type");
    }

    if (this.form.value.key === null && this.form.value.key === undefined) {
      return this.tenementInsConfigService.errorToast(
        "Tenement Config Key is not found"
      );
    }

    console.log(
      "this.form.value.key, this.form.value.tenementKey >> ",
      this.form.value.key,
      " ",
      this.form.value.tenementKey
    );

    this.tenementInsConfigService
      .getDocumentFile(this.form.value.key, this.form.value.tenementKey)
      .subscribe(
        (data) => {
          console.log(data);
          if (data.status === "SUCCESS") {
            console.log("File Name >> ", data);

            console.log("data.corrigendumFile >> ", data.corrigendumFile);
            console.log(
              "data.corrigendumFileName >> ",
              data.corrigendumFileName
            );
            if (
              (data.corrigendumFile === undefined ||
                data.corrigendumFile === null) &&
              (data.corrigendumFileName === undefined ||
                data.corrigendumFileName === null)
            ) {
              return this.tenementInsConfigService.errorToast(
                "Unable to donwload File."
              );
            } else {
              this.downloadFile(data.corrigendumFile, data.corrigendumFileName);
              // this.showFile(data.corrigendumFile, data.corrigendumFileName);
            }
          } else {
            this.tenementInsConfigService.errorToast("No File Found");
          }
        },
        (error) => {
          this.tenementInsConfigService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    console.log("base64 >> ", base64);
    console.log("fileName >> ", fileName);
    if (this.selectedFile) {
      const src = `${base64}`;
      console.log("src >> ", src);
      const link = document.createElement("a");
      link.href = src;
      link.download = fileName;
      link.click();
      link.remove();
    } else {
      const src = `data:application/pdf;base64,${base64}`;
      console.log("src >> ", src);
      const link = document.createElement("a");
      link.href = src;
      link.download = fileName;
      link.click();
      link.remove();
    }
  }

  async showFile(base64: string | ArrayBuffer, fileName: string) {
    const modal = await this.modalCtrl.create({
      component: ViewPdfComponent,
      componentProps: {
        base64: base64,
        documentName: "Corrigendum File",
        fileName: "CORRIGENDUM_FILE_" + new Date().getTime() + ".pdf",
      },
    });
    modal.present();
  }

  populateIntrestChartLst(intrestChartLst: any[]): FormGroup[] {
    const formGroups: FormGroup[] = [];
    const intrestChartArrayControl = this.form.get(
      "intrestChartLst"
    ) as FormArray;
    intrestChartArrayControl.clear();

    intrestChartLst.forEach((item) => {
      formGroups.push(
        new FormGroup({
          startDate: new FormControl(item.startDate, Validators.required),
          endDate: new FormControl(item.endDate),
          instPaymentInterestRate: new FormControl(
            item.instPaymentInterestRate,
            Validators.required
          ),
        })
      );
    });
    return formGroups;
  }

  allowOnlyNumbersAndDecimal(event) {
    const key = event.key;
    const regex = /^[0-9.]$/i;
    return regex.test(key);
  }
  onCancel() {
    return this.modalCtrl.dismiss(null, "close");
  }

  addResponsibility() {
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;

    if (
      selectedIntrestChartLst.length === 0 ||
      selectedIntrestChartLst
        .at(selectedIntrestChartLst.length - 1)
        ?.get("instPaymentInterestRate").value
    ) {
      if (
        selectedIntrestChartLst.length === 0 ||
        selectedIntrestChartLst
          .at(selectedIntrestChartLst.length - 1)
          ?.get("startDate").value
      ) {
        if (
          selectedIntrestChartLst.length === 0 ||
          selectedIntrestChartLst
            .at(selectedIntrestChartLst.length - 1)
            ?.get("endDate").value
        ) {
          const previousEndDate =
            selectedIntrestChartLst.length > 0
              ? selectedIntrestChartLst
                  .at(selectedIntrestChartLst.length - 1)
                  ?.get("endDate").value
              : null;
          const parsedEndDate =
            previousEndDate !== null ? new Date(previousEndDate) : null;

          const newStartDate =
            parsedEndDate !== null
              ? this.calculateNextDate(parsedEndDate)
              : null;

          selectedIntrestChartLst.push(
            new FormGroup({
              key: new FormControl(null),
              startDate: new FormControl(newStartDate, Validators.required),
              endDate: new FormControl(null),
              instPaymentInterestRate: new FormControl(
                null,
                Validators.required
              ),
            })
          );
        } else {
          this.installmentConfigService.errorToast(
            "End date not selected. Row not added."
          );
        }
      } else {
        this.installmentConfigService.errorToast(
          "Start date not selected. Row not added."
        );
      }
    } else {
      this.installmentConfigService.errorToast(
        "Interest Rate not selected. Row not added."
      );
    }
  }

  calculateNextDate(previousEndDate: Date): Date {
    if (previousEndDate instanceof Date && !isNaN(previousEndDate as any)) {
      const nextStartDate = new Date(previousEndDate);
      nextStartDate.setDate(previousEndDate.getDate() + 1);

      return nextStartDate;
    } else {
      // Handle the case where previousEndDate is not a valid Date
      return null; // Or handle it according to your logic
    }
  }

  get DetailOfFamilyMembers() {
    return this.form.get("intrestChartLst")["controls"];
  }

  deleteResponsibility(i: number) {
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;
    selectedIntrestChartLst.removeAt(i);
  }

  showOtherInstallmentT(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  editSavedConfigAmt() {
    this.isAmountReadOnly = false;
  }

  onFileSelect(event) {
    if (event.target.files[0].size < 2 * 1024 * 1024) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile && this.selectedFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.corrigendumDocFile = reader.result;
          this.corrigendumDocFileForView = this.corrigendumDocFile;
          const fileNameParts = this.selectedFile.name.split(".");
          this.corrigendumDocFileName = this.selectedFile.name;
          const fileNameWithoutExtension = fileNameParts[0];
          this.docNameWithoutExtnsn = fileNameWithoutExtension;
        };
      } else {
        this.selectedFile = null;
        this.corrigendumDocFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile = null;
      this.corrigendumDocFile = null;
      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }
  openPreviewOtherDocumentFile() {
    this.PreviewOtherDocumentfile(this.corrigendumDocFileForView);
  }

  async PreviewOtherDocumentfile(base64) {
    console.log("In PreviewOtherDocumentfile >");
    this.isLoading = true;
    this.isLoading = false;
    const base64Data = base64.split(",")[1];
    const modal = await this.modalCtrl.create({
      component: ViewPdfComponent,
      componentProps: {
        base64: base64Data,
        documentName: "Corrigendum Letter",
        fileName:
          "Corrigendum_" +
          "this.applicationNo" +
          "_" +
          new Date().getTime() +
          ".pdf",
      },
    });
    modal.present();
  }
}
